import React from 'react'
import Image from 'next/image'
import { InfoBarSectionProps } from '~types'
import { Button, Heading } from '~elements'
import { useWindowSize } from 'utils/hooks'
import styles from './InfoBarSection.module.scss'
import parse from 'html-react-parser'
import { NEXT_IMAGE_QUALITY } from '~constants'
import { getImageUrl } from 'utils/assets/getImageUrl'
import { ColorAliasNeutralWhite } from '~styles/dist/tokens.mjs'

const InfoBarSection = ({
  cta,
  defaultImg,
  description,
  eyebrow,
  icon,
  iconHeight,
  iconWidth,
  mobileImage,
  subheadline,
  subheadlineColor = ColorAliasNeutralWhite
}: InfoBarSectionProps) => {
  const { isBreakpoint: isBelowBreakpointMd } = useWindowSize('md', '<')
  const mobileImageUrl = getImageUrl({ imageUrl: mobileImage?.image?.url })
  const defaultImgUrl = getImageUrl({ imageUrl: defaultImg?.image?.url })
  const imgSrc = isBelowBreakpointMd ? mobileImageUrl : defaultImgUrl
  const imageAlt = isBelowBreakpointMd ? mobileImage?.alt : defaultImg?.alt
  const iconUrl = getImageUrl({ imageUrl: icon?.url })
  const linkModule = 'info_bar_section'

  return (
    <div className={styles['infobar-section']}>
      {imgSrc && (
        <div className={styles['infobar-section__image-container']}>
          <Image src={imgSrc} alt={imageAlt || ''} width={480} height={392} quality={NEXT_IMAGE_QUALITY} />
        </div>
      )}
      <div className={styles['infobar-section__copy']}>
        {eyebrow && (
          <Heading level={5} levelDisplay='eyebrow'>
            {eyebrow}
          </Heading>
        )}
        {iconUrl && (
          <div className={styles['media-column']}>
            <Image
              width={iconWidth || 33}
              height={iconHeight || 33}
              sizes='100vw'
              alt={icon?.altText || ''}
              src={iconUrl}
            />
          </div>
        )}
        {subheadline && (
          <Heading level={2} color={subheadlineColor} justify={'left'}>
            {subheadline}
          </Heading>
        )}
        {description && description?.html ? (
          <div className={styles['infobar-description']}>{parse(description.html)}</div>
        ) : null}
        {cta && (
          <div className={styles.button}>
            <Button
              {...cta}
              analytics={{
                linkModule: linkModule
              }}
            />
          </div>
        )}
      </div>
    </div>
  )
}
export default InfoBarSection
